import { jsx, css } from '@emotion/react';

import { connectLocation } from '../../location/LocationConnectors';
import Link from '../oc-link';

const styles = css`
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;

  .tel {
    color: #d40f7d;
    font-size: 28px;
    font-family: 'OCRoboto', sans-serif;
    font-weight: 700;
    text-decoration: none;
    text-transform: uppercase;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ContactUs = connectLocation(({ t }) => (
  <section css={styles}>
    <h2>{t('components.oc-contact-us.heading')}</h2>
    <p>{t('components.oc-contact-us.text')}</p>
    <Link className="tel" href={`tel:${t('components.oc-contact-us.tel')}`} data-track="phone">
      {t('components.oc-contact-us.cta')}
    </Link>
  </section>
));

ContactUs.WrappedComponent.displayName = 'ContactUs';

export default ContactUs;
